/* eslint-disable max-lines-per-function */
import { Tag } from 'primereact/tag'
import { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import UpsertPopup from '../../components/form/UpsertPopup'
import capPhatVanBangProcessor from '../../processor/capPhatVanBangProcessor'
import truongProcessor from '../../processor/truongProcessor'
import userProcessor from '../../processor/userProcessor'
import { dateToDDMMYY } from '../../utils/date'
import HuyCapPhat from './HuyCapPhat'
import LichSuCapPhat from './LichSuCapPhat'
import ListVanBangWithView from './ListVanBangWithView'

const CapPhat = () => {
  const user = useSelector((store) => store.user)
  const [value, setValue] = useState({})
  const [users, setUsers] = useState([])
  const [truongs, setTruongs] = useState([])
  const [visible, setVisible] = useState(false)
  const [visibleConfirm, setVisibleConfirm] = useState(false)
  const [visibleHistory, setVisibleHistory] = useState(false)
  const [reload, setReload] = useState(false)
  const toggle = () => setVisible(!visible)
  const toggleConfirm = () => setVisibleConfirm(!visibleConfirm)
  const toggleHistory = () => setVisibleHistory(!visibleHistory)
  const toast = useSelector((store) => store.notify.toast)

  const today = new Date()
  const dd = String(today.getDate()).padStart(2, '0')
  const mm = String(today.getMonth() + 1).padStart(2, '0') // Tháng bắt đầu từ 0
  const yyyy = today.getFullYear()

  const current = `${dd}/${mm}/${yyyy}`

  useEffect(async () => {
    const rs = await userProcessor.getAll()
    setUsers(rs)
    const trgs = await truongProcessor.getAll()
    setTruongs(trgs)
  }, [])
  const additionColumn = [
    {
      value: 'truong',
      name: 'Trường',
      render: (data) => {
        const truong = truongs.find((item) => item.id === data.truongId)
        return truong && truong.name
      },
    },
    {
      value: 'chinhSuaVanBangs',
      name: 'Trạng thái',
      render: (data) => {
        const userCapPhat = users.find((item) => item.id === data.nguoiCapPhatId)
        return data.daCapPhat ? (
          <Tag
            severity="success"
            value={`[${userCapPhat && userCapPhat.fullname}][${
              data.ngayCapPhat && dateToDDMMYY(new Date(data.ngayCapPhat))
            }] đã cấp phát cho người có cccd: ${data.canCuocCongDanNguoiNhan}`}
          />
        ) : (
          <Tag severity="danger" value="Chưa cấp phát" />
        )
      },
    },
    {
      value: 'fileDinhKemCapPhat',
      name: 'File đính kèm',
      render: (data) => {
        return data.fileDinhKemCapPhat ? (
          <a href={data.fileDinhKemCapPhat} target="_blank" rel="noopener noreferrer">
            Tải về
          </a>
        ) : (
          ''
        )
      },
    },
  ]
  const buttons = [
    (data) => {
      return {
        icon: 'pi pi-send',
        className: 'p-button-rounded p-button-success mr-2',
        tooltip: 'Cấp phát',
        tooltipOptions: { position: 'top' },
        visible: !data.daCapPhat,
        onClick: () => {
          setValue({
            ...data,
            nguoiCapPhatId: user.info.id,
            canCuocCongDanNguoiNhan: data.cccd,
            hoTenNguoiNhan: data.hoTen,
            date: current,
          })
          toggle()
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-envelope',
        className: 'p-button-rounded p-button-warning mr-2',
        tooltip: 'Cấp phát hộ',
        tooltipOptions: { position: 'top' },
        visible: !data.daCapPhat,
        onClick: () => {
          setValue({ ...data, nguoiCapPhatId: user.info.id, date: current })
          toggle()
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-pencil',
        className: 'p-button-rounded p-button-success mr-2',
        visible: data.daCapPhat,
        tooltip: 'Chỉnh sửa',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          setValue({
            ...data,
            date: data.ngayCapPhat && dateToDDMMYY(new Date(data.ngayCapPhat)),
            nguoiCapPhatId: user.info.id,
          })
          toggle()
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-history',
        className: 'p-button-rounded p-button mr-2',
        tooltip: 'Lịch sử cấp phát',
        tooltipOptions: { position: 'top' },
        onClick: () => {
          setValue(data)
          toggleHistory()
        },
      }
    },
    (data) => {
      return {
        icon: 'pi pi-trash',
        className: 'p-button-rounded p-button-danger mr-2',
        tooltip: 'Huỷ cấp phát',
        tooltipOptions: { position: 'top' },
        visible: data.daCapPhat,
        onClick: () => {
          toggleConfirm()
          setValue({ ...data })
        },
      }
    },
  ]

  const submit = async (data) => {
    const submitData = { ...data }
    if (data.ngayCapPhat) {
      submitData.ngayCapPhat = null
      if (!data.date) {
        submitData.date = dateToDDMMYY(new Date(data.ngayCapPhat))
      }
    }
    const rs = await capPhatVanBangProcessor.upsert(submitData)
    const message = rs.data
    if (rs.isSuccess) {
      setReload(true)
      toggle()
    }
    toast({ type: rs.isSuccess ? 'success' : 'error', message })
  }
  const deleteOnClick = async (confirm) => {
    if (confirm) {
      const rs = await capPhatVanBangProcessor.delete(confirm)
      toast({ type: rs.isSuccess ? 'success' : 'error', message: rs.data })
      if (rs.isSuccess) setReload(true)
    }
  }

  return (
    <>
      <LichSuCapPhat visible={visibleHistory} toggle={toggleHistory} id={value.id} />
      <HuyCapPhat
        id={value.id}
        visible={visibleConfirm}
        toggle={toggleConfirm}
        load={deleteOnClick}
        header="Xác nhận"
        body="Bạn có muốn huỷ cấp phát văn bằng này?"
      />
      <UpsertPopup
        header="Cấp phát văn bằng"
        onSave={submit}
        data={value}
        fields={
          value.canCuocCongDanNguoiNhan && value.hoTenNguoiNhan && !value.daCapPhat
            ? ['nguoiCapPhatId', 'date', 'ghiChuCapPhat']
            : [
                'nguoiCapPhatId',
                'date',
                'hoTenNguoiNhan',
                'fileDinhKemCapPhat',
                'canCuocCongDanNguoiNhan',
                'ghiChuCapPhat',
              ]
        }
        required={['date', 'hoTenNguoiNhan', 'canCuocCongDanNguoiNhan']}
        name={{
          nguoiCapPhatId: 'Người cấp',
          date: 'Ngày cấp phát',
          hoTenNguoiNhan: 'Họ tên người nhận',
          fileDinhKemCapPhat: 'File đính kèm',
          ghiChuCapPhat: 'Ghi chú',
          canCuocCongDanNguoiNhan: 'Căn cước công dân',
        }}
        types={{
          nguoiCapPhatId: 'select',
          fileDinhKemCapPhat: 'file',
          date: 'date',
          ghiChuCapPhat: 'text-area',
        }}
        col={{ ghiChuCapPhat: 12, canCuocCongDanNguoiNhan: 12 }}
        options={{
          nguoiCapPhatId: users.map((item) => {
            return { ...item, name: item.userName }
          }),
        }}
        disable={['nguoiCapPhatId']}
        visible={visible}
        toggle={toggle}
      />
      <ListVanBangWithView
        dontShow
        moduleTitle="Cấp phát văn bằng"
        additionColumn={additionColumn}
        buttons={buttons}
        reload={reload}
        setReload={setReload}
        getMethod={capPhatVanBangProcessor.getByKhoaThi}
      />
    </>
  )
}

export default CapPhat
